<template>
  <div>
    <form-section
      :title="$t('Automations_Title_Schedule')"
      :description="$t('Automations_Title_Schedule_Description')"
    >
      <recurrence-settings
        :model="model.schedule"
        :timezone="$store.state.app.project.timezone"
        :disabled="readonly"
        :delta="model.config.delta"
      />
    </form-section>
  </div>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import RecurrenceSettings from '@/modules/automations/components/RecurrenceSettings'

export default {
  name: 'StepExportExecutionSchedule',
  props: {
    model: {
      default: null
    },
    readonly: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {}
  },
  mounted() {
    this.allowContinue()
  },
  components: {
    RecurrenceSettings,
    FormSection
  },
  methods: {
    allowContinue() {
      this.$emit('can-continue', { value: true })
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/automations/components/StepExportExecutionSchedule.vue